import { supabase } from "@/shared/lib/supabase";

export const analysisExport = {
  exportPdf: (analysisId: string) =>
    supabase.functions.invoke<{ file_url: string }>("create-export-pdf", {
      body: { analysis_id: analysisId },
    }),
};
